import React, { createContext, ReactNode, useContext } from 'react';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

import useIsRetail from './useIsRetail';

type Props = {
  children: ReactNode;
  venues: Venue[];
};

const RetailContext = createContext<boolean>(false);

export const RetailContextProvider = ({ children, venues }: Props) => {
  const isRetail = useIsRetail(venues);
  return <RetailContext.Provider value={isRetail}>{children}</RetailContext.Provider>;
};

export default () => useContext(RetailContext);
